import { render, staticRenderFns } from "./CallWorkerRelativeList.vue?vue&type=template&id=810b08b6&scoped=true&"
import script from "./CallWorkerRelativeList.vue?vue&type=script&lang=ts&"
export * from "./CallWorkerRelativeList.vue?vue&type=script&lang=ts&"
import style0 from "./CallWorkerRelativeList.vue?vue&type=style&index=0&id=810b08b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810b08b6",
  null
  
)

export default component.exports